import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  users,
  listUser,
  spinner,
  devices,
  groups,
  sendEmail,
  verifyToken,
  enrollOrganization,
  inviteUser,
  verifyUserInvitationToken,
  getMobileLicenseUsers,
  manageMobileLicenseUsers,
  deviceSetup,
  createGroup,
  editGroup,
  createUser,
  deleteModal,
  deleteDeviceModal,
  pendingDeletions,
  updateDeviceModal,
  unassignDeviceModal,
  editOrganization,
  updateOrganizationFirmwareVersion,
  updateOrganizationIotAgentVersion,
  assignDevices,
  createAlert,
  alerts,
  deleteAlert,
  editAlert,
  endAlert,
  listApprovalAlertApi,
  approveAlertApi,
  denyAlertApi,
  createDas,
  listAlertTypes,
  dasSubscriptions,
  organizations,
  updateOrgStatus,
  resendAlert,
  deleteSubscription,
  editSubscription,
  deleteUser,
  updateUser,
  dashboardApi,
  signInApi,
  signOutApi,
  sendResetPasswordEmailApi,
  resetPasswordApi,
  createEditGroupModal,
  createEditAlertModal,
  sendDasAlert,
  alertAction,
  listFirmwareApi,
  listIotAgentApi,
  uploadFirmwareApi,
  uploadIotAgentApi,
  deviceLogs,
  singlewireToken,
  singlewireSite,
  mapSinglewireSites,
  everbridgeToken,
  everbridgeGroup,
  mapEverbridgeGroup,
  listAlertusTokens,
  deleteAlertusToken,
  createAlertusToken,
  listQuickAlerts,
  createQuickAlerts,
  editQuickAlerts,
  deleteQuickAlerts,
  sendQuickAlerts,
  approvePublicApiUser,
  listPublicApiTokens,
  revokePublicApiToken,
  getPublicApiApprovalStatus,
  rebootDevice,
  organisationLicenses,
  mobileLicensing,
  analyticsFilter,
  organizationsAnalytics,
  deviceAnalytics,
  alertsAnalytics,
  integrationsAnalytics,
  versionDistribution,
  usersAnalytics,
  deviceUpdateReport,
  createPublicAPIToken,
  userGuide,
  templates,
  listCapEndpoints,
  createCapEndpoint,
  updateCapEndpoint,
  deleteCapEndpoint,
  regenerateCapEndpointToken,
  superAdminDevicesApi,
  superAdminDeleteDeviceApi,
} from './reducers';

const initialState = {};

const store = configureStore({
  reducer: combineReducers({
    users,
    listUser: listUser,
    listPublicApiTokens: listPublicApiTokens,
    getPublicApiApprovalStatus: getPublicApiApprovalStatus,
    organisationLicenses: organisationLicenses,
    revokePublicApiToken: revokePublicApiToken,
    deleteUser: deleteUser,
    updateUser: updateUser,
    spinner,
    mobileLicensing,
    groupApi: groups,
    deleteModal: deleteModal,
    deviceApi: devices,
    deviceSetup: deviceSetup,
    createGroup: createGroup,
    assignDevices: assignDevices,
    editGroup: editGroup,
    createUser: createUser,
    sendEmailApi: sendEmail,
    verifyTokenApi: verifyToken,
    deleteDeviceApi: deleteDeviceModal,
    pendingDeletions: pendingDeletions,
    updateDeviceApi: updateDeviceModal,
    unassignDeviceApi: unassignDeviceModal,
    alertsApi: alerts,
    sendDasAlert: sendDasAlert,
    organizationsApi: organizations,
    editOrganization: editOrganization,
    updateOrganizationFirmwareVersion: updateOrganizationFirmwareVersion,
    updateOrganizationIotAgentVersion: updateOrganizationIotAgentVersion,
    updateOrgStatus: updateOrgStatus,
    deleteAlertApi: deleteAlert,
    endAlertApi: endAlert,
    enrollOrganizationApi: enrollOrganization,
    inviteUserApi: inviteUser,
    verifyUserInvitationTokenApi: verifyUserInvitationToken,
    getMobileLicenseUsersApi: getMobileLicenseUsers,
    manageMobileLicenseUsersApi: manageMobileLicenseUsers,
    createAlert: createAlert,
    editAlert: editAlert,
    listApprovalAlertApi: listApprovalAlertApi,
    approveAlertApi: approveAlertApi,
    denyAlertApi: denyAlertApi,
    resendAlert: resendAlert,
    createDasApi: createDas,
    listAlertTypesApi: listAlertTypes,
    dasSubscriptionsApi: dasSubscriptions,
    deleteSubscriptionApi: deleteSubscription,
    editSubscriptionApi: editSubscription,
    dashboardApi: dashboardApi,
    signInApi: signInApi,
    signOutApi: signOutApi,
    sendResetPasswordEmailApi: sendResetPasswordEmailApi,
    resetPasswordApi: resetPasswordApi,
    createEditGroupModal,
    createEditAlertModal,
    alertAction: alertAction,
    listFirmwareApi: listFirmwareApi,
    listIotAgentApi: listIotAgentApi,
    uploadFirmwareApi: uploadFirmwareApi,
    uploadIotAgentApi: uploadIotAgentApi,
    deviceLogs: deviceLogs,
    singlewireTokenApi: singlewireToken,
    singlewireSiteApi: singlewireSite,
    mapSinglewireSitesApi: mapSinglewireSites,
    everbridgeTokenApi: everbridgeToken,
    everbridgeGroupApi: everbridgeGroup,
    mapEverbridgeGroupsApi: mapEverbridgeGroup,
    listAlertusTokens,
    deleteAlertusToken,
    createAlertusToken,
    listQuickAlertsApi: listQuickAlerts,
    createQuickAlertsApi: createQuickAlerts,
    editQuickAlertsApi: editQuickAlerts,
    deleteQuickAlertsApi: deleteQuickAlerts,
    sendQuickAlertsApi: sendQuickAlerts,
    approvePublicApiUserApi: approvePublicApiUser,
    rebootDeviceApi: rebootDevice,
    analyticsFilter: analyticsFilter,
    organizationsAnalytics: organizationsAnalytics,
    deviceAnalytics: deviceAnalytics,
    alertsAnalytics: alertsAnalytics,
    integrationsAnalytics: integrationsAnalytics,
    versionDistribution: versionDistribution,
    usersAnalytics: usersAnalytics,
    deviceUpdateReport: deviceUpdateReport,
    createPublicAPIToken: createPublicAPIToken,
    userGuide: userGuide,
    templates: templates,
    listCapEndpoints: listCapEndpoints,
    createCapEndpoint: createCapEndpoint,
    updateCapEndpoint: updateCapEndpoint,
    deleteCapEndpoint: deleteCapEndpoint,
    regenerateCapEndpointToken: regenerateCapEndpointToken,
    superAdminDevicesApi: superAdminDevicesApi,
    superAdminDeleteDeviceApi: superAdminDeleteDeviceApi,
  }),
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ thunk: true }),
    // logger,
  ],
  devTools: process.env.NODE_ENV !== 'production',
  ...initialState,
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
